var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var debounce = require('debounce');
var vein = require('veinjs');

function applySizeClasses() {
  var wh = window.innerHeight;
  var ww = window.innerWidth;
  var hh = 70;
  var fh = $('footer.footer').outerHeight();
  var ph = wh - hh;

  vein.inject('.full-height, .contact-form .gform_confirmation_wrapper', {
    'height': ph+'px'
  });

  vein.inject('.max-width-window', {
    'max-width': ww+'px'
  });

  vein.inject('.main-content', {
    'min-height': (wh - fh - hh)+'px'
  });

  $(window).trigger('vsc-page-resized');
}

module.exports = function() {
  applySizeClasses();
  
  $(window).on('resize.vsc-size-classes', debounce(applySizeClasses, 200));
}